var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "leftBox" }, [
      _c("div", { staticClass: "leftBox_top" }, [
        _c("div", { staticClass: "record_num" }, [
          _c("div", [
            _c("div", { staticClass: "record_num_box" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.elCarouselList.bidopenCount))]),
                _vm._v(" 宗"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.dateName))]),
            ]),
            _c("div", { staticClass: "record_num_des" }, [
              _vm._v("待开标监管数量"),
            ]),
          ]),
          _c("div", [
            _c("div", { staticClass: "record_num_box" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.elCarouselList.evalCount))]),
                _vm._v(" 宗"),
              ]),
              _c("div", [_vm._v(_vm._s(_vm.dateName))]),
            ]),
            _c("div", { staticClass: "record_num_des" }, [
              _vm._v("待评标监管数量"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "time_box" },
          [
            _c("Acalender", {
              attrs: {
                dateType: _vm.elCarouselList.dateType,
                calendarListData: _vm.calendarListData,
                currentHandleCarouseType: _vm.currentHandleCarouseType,
              },
              on: {
                "update:dateType": function ($event) {
                  return _vm.$set(_vm.elCarouselList, "dateType", $event)
                },
                "update:date-type": function ($event) {
                  return _vm.$set(_vm.elCarouselList, "dateType", $event)
                },
                "update:calendarListData": function ($event) {
                  _vm.calendarListData = $event
                },
                "update:calendar-list-data": function ($event) {
                  _vm.calendarListData = $event
                },
                "update:currentHandleCarouseType": function ($event) {
                  _vm.currentHandleCarouseType = $event
                },
                "update:current-handle-carouse-type": function ($event) {
                  _vm.currentHandleCarouseType = $event
                },
                calenderDateChange: _vm.calenderDateChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "leftBox_bottom" },
        [
          _c("card-list", {
            attrs: {
              cardList: _vm.cardDataList,
              total: _vm.cardTotal,
              cardPageIndex: _vm.cardPageIndex,
            },
            on: {
              "update:cardList": function ($event) {
                _vm.cardDataList = $event
              },
              "update:card-list": function ($event) {
                _vm.cardDataList = $event
              },
              "update:total": function ($event) {
                _vm.cardTotal = $event
              },
              "update:cardPageIndex": function ($event) {
                _vm.cardPageIndex = $event
              },
              "update:card-page-index": function ($event) {
                _vm.cardPageIndex = $event
              },
              queryCardListMore: _vm.queryCardListMore,
              openBidWitnessDetail: _vm.router_toOpen,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }